import { createI18n } from "vue-i18n";
import { createModernI18nOptions } from "./config";

export function createModernI18n() {
  return createI18n(createModernI18nOptions());
}
